'use client';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { BaseQuotePageProps } from '../../../../../src/utils/quote/types';
import UnusualOptions from '../../../../../src/components/Quote/unusualOptions';
import type { IDateRange } from '@benzinga/calendars';
import type { UnusualOptionsCalendarDataSet } from '@benzinga/calendar-manager';
import SeeMoreLink from '../_components/SeeMoreLink';
import { seeMoreDestinations } from '../_utils/seeMoreDestinations';

interface UnusualOptionsContentProps extends BaseQuotePageProps {
  calendarDataSet: UnusualOptionsCalendarDataSet[] | null;
  initialDateRange?: IDateRange | null;
}

const UnusualOptionsContent: React.FC<UnusualOptionsContentProps> = ({ calendarDataSet, profile, symbol }) => {
  const { t } = useTranslation('quote');

  return (
    <>
      {(calendarDataSet?.length ?? 0) > 0 && (
        <div className="flex justify-end px-4">
          <SeeMoreLink
            action="see_more_unusual_options"
            href={seeMoreDestinations.unusualOptions(symbol)}
            label={t('Quote.SeeMore.unusual-options')}
          />
        </div>
      )}
      <UnusualOptions calendarDataSet={calendarDataSet ?? []} profile={profile} symbol={symbol} />
    </>
  );
};

export default UnusualOptionsContent;
